import { MapsAPILoader } from '@agm/core';
import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { resolve } from 'url';
import { callbackify } from 'util';
import { ConstructionL1Component } from '../courses-layouts/construction-l1/construction-l1.component';
declare var google;

@Injectable({
  providedIn: 'root'
})
export class MapsService {

  latitude: number
  longitude: number
  zoom: number
  address: string;
  location: any;
  addr: unknown;
  currentLocation: any
  private geoCoder
  private distanceCoder

  constructor(
    private apiloader: MapsAPILoader,
    private ngZone: NgZone,
  ) {
    this.apiloader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;
      this.distanceCoder = new google.maps.DistanceMatrixService
      this.setCurrentLocation();
      // this.getDistance()
      console.log("hello here constor call and work....", this.geoCoder)
    }).catch((error: any) => {
      console.log('Error loading maps api', error);
    });
  }

  // ngOnInit() {
  //   this.apiloader.load().then(() => {
  //     this.geoCoder = new google.maps.Geocoder;
  //     this.distanceCoder = new google.maps.DistanceMatrixService
  //     this.setCurrentLocation();
  //     // this.getDistance()
  //     console.log("hello here constor call and work....", this.geoCoder)
  //   });
  // }

  public getDistance(origin, destination) {
    return new Promise((resolve, reject) => {
      this.apiloader.load().then(() => {
        console.log("CALL THIS FUNCTION OR NOT FOR DISTANCE", origin, destination);
        let distanceCoder = new google.maps.DistanceMatrixService
        const origin1 = { lat: 55.93, lng: -3.118 };
        const origin2 = "Greenwich, England";
        const destinationA = "Stockholm, Sweden";
        const destinationB = { lat: 50.087, lng: 14.421 };
        let origin44 = new google.maps.LatLng(Number(origin[1]), Number(origin[0]), true)
        let origin45 = new google.maps.LatLng(Number(destination[1]), Number(destination[0]))
        console.log("ORIGIN COORDINATED", origin44)
        console.log("DESTINATION COORDINETS", origin45)
        distanceCoder.getDistanceMatrix({
          origins: [origin44],
          destinations: [origin45],
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC,
          avoidHighways: false,
          avoidTolls: false,
        }, (response, status) => {
          console.log("THIS IS VERY IMPORTANT DATA TO BE CALLED", response, status);
          if (status === 'OK') {
            resolve(response)
          }else resolve(response)
        })
      }).catch((error) => {
        console.log("ERROR WHILE LOAD GOOGLE MAP", error)
      })
    })
  }

  setCurrentLocation(): Observable<any> {

    return new Observable<any>((observer) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          console.log("here is the position of the map.....", position)
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          // this.geoCoder = new google.maps.Geocoder;
          // this.getDistance()

          this.getAddress(this.latitude, this.longitude).then((res) => {
            console.log("Response of getAddress()", res)
            this.zoom = 15;
            this.addr = res
            let data = {
              latitude: this.latitude,
              longitude: this.longitude,
              address: this.addr
            }
            console.log("here code is work...", data)
            observer.next(data);

          }).catch((error) => {
            console.log("here is the error ", error)
          })
          // console.log("here code is work...", this.latitude, this.longitude)
          // let data = {
          //   latitude: this.latitude,
          //   longitude: this.longitude,
          //   address: this.addr

          // }

        });
      } else {
        console.log('Geoloc not found');
      }
    });
  }
  markerDragEnd(event): Observable<any> {
    return new Observable<any>((observer) => {
      console.log('mark drag event check', event);
      this.latitude = event.coords.lat;
      this.longitude = event.coords.lng;
      console.log(this.latitude, this.longitude)
      this.getAddress(this.latitude, this.longitude).then((res) => {
        console.log("Response of getAddress()", res)
        this.addr = res
        let data = {
          latitude: this.latitude,
          longitude: this.longitude,
          address: this.addr
        }
        observer.next(data);
      }).catch((err) => {
        console.log("Error of getAddress() ", err)
      })

    })
  }

  getAddress(latitude, longitude) {
    console.log("getAddress(latitude, longitude)", latitude, longitude)

    return new Promise((resolve, reject) => {
      console.log('BEFORE API LOAD, GET ADDRESS', this.apiloader);
      this.apiloader.load().then(() => {
        let geocoder = new google.maps.Geocoder;
        let latlng = {
          lat: this.latitude,
          lng: this.longitude
        };
        console.log('API LOADER IN GET ADDRESS', geocoder);
        geocoder.geocode({
          'location': latlng
        }, (results: any) => {
          console.log("here is the result of the map", results)
          if (results[0]) {
            console.log("what is the result", results);
            this.currentLocation = results[0].formatted_address;
            // return this.currentLocation
            console.log('Address::', this.currentLocation);
            resolve(this.currentLocation)

          } else {
            console.log('Not found');
          }
        });
      }).catch((error) => {
        console.log("ERROR WHILE LOAD MAP", error)
      });
    });
  }


  getCurrentAddress() {
    console.log("getAddress(latitude, longitude)", this.latitude, this.longitude)
    this.geoCoder = new google.maps.Geocoder();
    // let lat = (latitude) ? latitude : this.latitude
    // let lng = (longitude) ? longitude : this.longitude
    return new Observable<any>((observer) => {
      this.geoCoder.geocode({ 'location': { lat: this.latitude, lng: this.longitude } }, (results, status) => {
        console.log(results, "results");
        console.log(status, "status");
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.address = results[0].formatted_address;
            console.log('address found', this.address)
            // resolve(results[0].formatted_address)
            let data = {
              latitude: this.latitude,
              longitude: this.longitude,
              address: this.address
            }
            observer.next(data);
            // return this.address
          } else {
            window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      });
    });
  }

  getLocation(address: string): Observable<any> {
    console.log('Getting address: ', address);
    return new Observable<any>((observer) => {
      this.apiloader.load().then(() => {
        this.geoCoder = new google.maps.Geocoder();
        this.geoCoder.geocode({
          'address': address
        }, (results, status) => {
          console.log("What is the result of this", results);
          if (status == google.maps.GeocoderStatus.OK) {
            observer.next(results[0].geometry.location);
            observer.complete();
          } else {
            console.log('Error: ', results, ' & Status: ', status);
            observer.error();
          }
        });
      });
    })
  }

}



